import React from "react";
import { Grid } from "@mui/material";
import { FastField } from "formik";
import TextField from "@mui/material/TextField";

export default function ClientWarehouseAddressFields() {
  return (
    <>
      <Grid item xs={12}>
        <FastField
          fullWidth
          name="street"
          label="Calle"
          as={TextField}
        />
      </Grid>
      <Grid item xs={6}>
        <FastField
          fullWidth
          name="outNum"
          label="Número exterior"
          as={TextField}
        />
      </Grid>
      <Grid item xs={6}>
        <FastField
          fullWidth
          name="innNum"
          label="Número interior"
          as={TextField}
        />
      </Grid>
      <Grid item xs={12}>
        <FastField
          fullWidth
          name="colony"
          label="Colonia"
          as={TextField}
        />
      </Grid>
      <Grid item xs={12}>
        <FastField
          fullWidth
          name="municipality"
          label="Municipio"
          as={TextField}
        />
      </Grid>
      <Grid item xs={6}>
        <FastField
          fullWidth
          name="state"
          label="Estado"
          as={TextField}
        />
      </Grid>
      <Grid item xs={6}>
        <FastField
          fullWidth
          name="country"
          label="País"
          as={TextField}
        />
      </Grid>
      <Grid item xs={12}>
        <FastField
          fullWidth
          name="cp"
          label="Código postal"
          as={TextField}
        />
      </Grid>
    </>
  );
}
